import React, { Component } from "react";
import ProductItem from "./ProductItem";
import { inject, observer } from "mobx-react";
import Http from "axios";
import config from "../config";
import InfiniteScroll from "./InfiniteScroll";
import { sortBy, debounce } from "lodash";

const _ = {
  sortBy,
  debounce
};

@inject("UserStore", "DownloadsStore")
@observer
class Shop extends Component {
  state = {
    companies: [],
    category: false,
    subCategory: false,
    sorting: {
      name: "createdAt",
      type: "desc"
    }
  };

  searchProducts = _.debounce(async query => {
    const products = await (query
      ? Http.get(`${config.api}/products/search/${query}`, {
          withCredentials: true
        })
      : { data: { result: [] } });
    this.props.DownloadsStore.setSearchProducts(products.data.result, query);
  }, 1500);

  componentDidMount = async () => {
    await this.props.UserStore.getMyDownloads();
    await Promise.all([
      this.props.DownloadsStore.getProducts(),
      this.props.DownloadsStore.getCategories(),
      this.props.DownloadsStore.getBrands()
    ]);
    if (this.props.match.params.category) {
      const categoryIndex = this.props.DownloadsStore.categories
        .map(category => category._id)
        .indexOf(this.props.match.params.category);
      const category =
        categoryIndex > -1
          ? this.props.DownloadsStore.categories[categoryIndex]
          : false;
      const categoryId = category.parentCategory
        ? category.parentCategory
        : category._id;
      const subCategoryId = category.parentCategory ? category._id : false;
      this.setState({
        category: categoryId,
        subCategory: subCategoryId
      });
    }
  };

  setCompany = company => {
    this.setState(
      {
        companies:
          this.state.companies.indexOf(company) > -1
            ? [
                ...this.state.companies.slice(
                  0,
                  this.state.companies.indexOf(company)
                ),
                ...this.state.companies.slice(
                  this.state.companies.indexOf(company) + 1,
                  this.state.companies.length
                )
              ]
            : [...this.state.companies, company]
      },
      async () => {
        console.log("Setting Products page");
        await this.props.DownloadsStore.setProductsPage(
          this.state.sorting,
          1,
          true,
          this.props.DownloadsStore.category,
          this.state.companies
        );
      }
    );
  };

  getCategories() {
    const subCategories = this.props.DownloadsStore.categories.reduce(
      (subCats, category) => [...subCats, ...category.subCategories],
      []
    );

    return this.props.DownloadsStore.categories.filter(
      category => subCategories.indexOf(category._id) === -1
    );
  }

  getSubCategories(parent) {
    return this.props.DownloadsStore.categories.reduce(
      (subCats, subCategory) =>
        subCategory._id === parent
          ? [
              ...subCats,
              ...this.props.DownloadsStore.categories.filter(
                category => subCategory.subCategories.indexOf(category._id) > -1
              )
            ]
          : subCats,
      []
    );
  }

  getProducts() {
    return this.props.DownloadsStore.searching
      ? this.props.DownloadsStore.searchedProducts
      : this.props.DownloadsStore.products.docs;
  }

  changeSorting(name) {
    const sorting =
      this.state.sorting.name === name
        ? this.state.sorting.type === "desc"
          ? {
              ...this.state.sorting,
              type: "asc"
            }
          : {
              ...this.state.sorting,
              type: "desc"
            }
        : {
            name,
            type: "desc"
          };
    this.setState({
      sorting
    });
    this.props.DownloadsStore.setProductsPage(
      sorting,
      1,
      true,
      this.props.DownloadsStore.category,
      this.state.companies
    );
  }

  render() {
    return (
      <div className="main-content">
        <div className="section-title standalone">
          <p>DOWNLOADS</p>
          <div className="sep" />
        </div>
        <div className="shop-holder">
          <div className="shop-container" ref="shopContainer">
            <InfiniteScroll
              pageStart={0}
              initialLoad={false}
              loadMore={() =>
                this.props.DownloadsStore.setProductsPage(
                  this.state.sorting,
                  false,
                  false,
                  this.props.DownloadsStore.category,
                  this.state.companies
                )
              }
              hasMore={
                this.props.DownloadsStore.page <
                this.props.DownloadsStore.products.pages
              }
              scrollParent={this.refs.shopContainer}
              useWindow={false}
              useCapture={true}
              threshold={100}
            >
              {this.getProducts().map(product => (
                <ProductItem
                  key={product._id}
                  product={product}
                  id={product._id}
                  name={product.name}
                  price={product.pricePerDay.toFixed(2)}
                  image={product.images.length > 0 ? product.images[0] : null}
                  downloadMode={true}
                />
              ))}
            </InfiniteScroll>
          </div>
        </div>
        <div className="pagination-tabs" />
      </div>
    );
  }
}

export default Shop;



// WEBPACK FOOTER //
// ./src/components/DownloadsShop.js